/*
 Created by qing 2020/2/11 8:31 下午
 */

import {MIX_FORM_NAME} from "../../assets/js/base_config";
import boolean from "less/lib/less/functions/boolean";

// userInfo 的 map 版本
export function userListMap(state) {
  // let map = {}
  // state.userList.forEach(user => {
  //   map[user.userId] = user
  // })
  // return map
  return state.memberDetailMap
}

// 角色map
export function roleListMap(state) {
  let map = {}
  state.roleList.forEach(role => {
    map[role.roleCustomId] = role
  })
  return map
}

// 角色map
export function rolesMap(state) {
  let map = {}
  state.roleList.forEach(role => {
    map[role.roleCustomId] = role
  })
  return map
}

// 部门map
export function depListMap(state) {
  // let map = {}
  // if (state.organization.subDepList && state.organization.subDepList.length) {
  //   eachDep(state.organization.subDepList)
  // }
  // return map
  //
  // function eachDep(list) {
  //   list.forEach(dep => {
  //     map[dep.depId] = dep
  //     if (dep.subDepList && dep.subDepList.length) eachDep(dep.subDepList)
  //   })
  // }
  let map = {}
  if (state.depInfo.subDepList && state.depInfo.subDepList.length) {
    eachDep(state.depInfo.subDepList)
  }
  return map

  function eachDep(list) {
    list.forEach(dep => {
      map[dep.depId] = dep
      if (dep.subDepList && dep.subDepList.length) eachDep(dep.subDepList)
    })
  }
}

// userInfo 的 map 版本
export function leaveMemberListMap(state) {
  let map = {}
  state.leaveMemberList.forEach(user => {
    map[user.userId] = user
  })
  return map
}
// 已离职员工
export function leaveMemberList(state) {
  return state.leaveMemberList
}

// 外部联系人
export function leaveExternalMap(state) {
  let extMap = {}
  state.leaveExternalList.forEach(item => {
    extMap[item.userId] = item
  })
  return extMap
}
// 已离职外部联系人
export function leaveExternalList(state) {
  return state.leaveExternalList
}

export function userId(state) {
  return state.userInfo ? state.userInfo.userId : state.userId
}

export function userInfo(state) {
  return state.userInfo
}

export function currentCompanyId(state) {
  return state.company ? state.company.companyId : state.companyId
}

export function company(state) {
  return state.company
}

export function companyList(state) {
  return state.companyList
}

export function currentAppId(state) {
  return state.appId
}

export function currentApp(state) {
  return state.activeApp
}

export function currentFormId(state) {
  return state.formId
}

// 外部联系人
export function extList(state) {
  return state.externalList
}
// 外部联系人
export function extMap(state) {
  // let extMap = {}
  // state.externalList.forEach(item => {
  //   extMap[item.userId] = item
  // })
  // return extMap
  return state.externalDetailMap
}
// 外部联系人标签
export function extLabelList(state) {
  return state.extLabelList
}
// 外部联系人标签
export function extLabelMap(state) {
  let labelMap = {}
  state.extLabelList.forEach(item => {
    if (item.labelNameList) {
      item.labelNameList.forEach(label => {
        labelMap[label.labelId] = label
      })
    }
  })
  return labelMap
}

export function adminInfo(state) {
  return state.adminInfo || {}
}

// 系统配置
export function systemConfig(state) {
  return state.systemConfig ? state.systemConfig : {}
}

// 网站名称
export function webName(state) {
  return state.systemConfig ? state.systemConfig.configMap.webName : ''
}

// 系统自定义配置
export function configMap(state) {
  return state.systemConfig ? state.systemConfig.configMap : {}
}

export function env(state) {
  return state.env
}

export function openId(state) {
  return state.openId
}

export function mix_form_name() {
  return MIX_FORM_NAME()
}

export function isGuest(state) {
  return state.userId === 1
}

export function functionConfigMap(state) {
  if (state.systemConfig && state.systemConfig.configMap && state.systemConfig.configMap.functionConfigMap) {
    return state.systemConfig.configMap.functionConfigMap
  } else {
    return  {}
  }
}

export function newRtf(state) {
  console.log('newRtf',state.personalizedConfig)
  return state.personalizedConfig && state.personalizedConfig.hasOwnProperty('newRtf') ? state.personalizedConfig.newRtf : 0
}

export function sys_tc_hot(state) {
  return functionConfigMap(state).hasOwnProperty('sys_tc_hot') &&
  functionConfigMap(state).sys_tc_hot.showFunction

}

export function pageTitle(state) {
  return state.pageTitle
}